import camelCase from '../lib/camelCase';
import Immutable from 'immutable';
import qs from "qs";
import {transformForApiRequest} from "../../../frontend/order/order";

function transformAdditionsFromApi(payload) {
    return camelCase(payload);
}


export function get(api, {order}) {
    return api.post(api.url('orders/additions'), {order: transformForApiRequest(order)}, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformAdditionsFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};
